import { useGetQuery } from "../../../../hooks/useClientPortalQuery";
import { AppointmentBookingClientModel } from "../../../../types/generated/models";
import { useClientPortalSelector } from "../../../../redux";
import { selectBooking } from "../../bookingSlice";
import { useAppointmentBookingApi } from "../../../../hooks/useAppointmentBookingApi";

export function useRelatedClients() {
    const { getEndpoint } = useAppointmentBookingApi();
    const { provider, session } = useClientPortalSelector(selectBooking);

    const bookingType = session.bookingType;

    const params = new URLSearchParams({
        practitionerId: provider.data?.providerId?.toString() ?? "",
        type: bookingType,
    });

    const { data, isLoading } = useGetQuery<AppointmentBookingClientModel[]>({
        url: `${getEndpoint("GetClients")}?${params.toString()}`,
        options: {
            enabled: !!provider.data?.providerId,
        },
    });

    return {
        relatedClients: data,
        isLoading,
    };
}
